module.exports = __webpack_public_path__ + "img/h_logo01.e969fb6.png";